import ExpertProfileEditReviewItemModule from './expert-profile-edit-review-item.module'

export default ExpertProfileEditReviewItemModule
